// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4264":"44408ab14b57cec1","7901":"02e9925b2fbd83c5"}[chunkId] + ".js";
};